export const DELAY_TIME_TO_HIDE_LETTERS_PANEL = 2000;
export const TIMER_NOTIFICATION_POPUP = 59000;
export const DELAY_BEFORE_PLAYER_START = 60000;
export const DELAY_BEFORE_CAN_UPDATE_TEMINAL_DATA = 10;
export const INTERVAL_CHECK_MAP_DATA_MODIFIED = 10;
export const INTERVAL_CHECK_MAP_OBJECTS = 300000;
export const RESET_TERMINAL_DATA = 60000;
